// 首页
export const GET_INDEX_INFO = 'GET_INDEX_INFO'
export const SET_INDEX_INFO = 'SET_INDEX_INFO'

// 幻灯片
export const GET_INDEX_CAROUSEL = 'GET_INDEX_CAROUSEL'
export const SET_INDEX_CAROUSEL = 'SET_INDEX_CAROUSEL'

// 系统可用产品
export const GET_HOT_PRODUCTS = 'GET_HOT_PRODUCTS'
export const SET_HOT_PRODUCTS = 'SET_HOT_PRODUCTS'



// WEBPACK FOOTER //
// ./src/vuex/types/main.js